<template>
  <div>
    <div class="exhibitor--inner__wrapper" v-if="exhibitors.length > 0">
      <div class="exhibitor-card" v-for="exhibitor in exhibitors" v-bind:key="exhibitor.Id">
        <div class="image-left">
          <img v-if="exhibitor.CompanyLogo == 'NA' || exhibitor.CompanyLogo == '' || exhibitor.CompanyLogo == null" :src="logoSrc" alt="">
          <img v-else :srcset="exhibitor.CompanyLogo" alt="" width="180" height="180">
        </div>
        <div class="content">
          <h6>{{ exhibitor.CompanyName }}</h6>
          <small>{{ exhibitor.CountryName }}
            <b>{{ exhibitor.StandNumber }}</b></small>
          <p>{{ exhibitor.Description }}</p>
          <!--<div class="d-flex"> <span v-for="products in exhibitor.ProductCategories"
              v-bind:key="products.ProductCategories">
              {{ products }}
            </span>
          </div>-->
        </div>
        <div class="btn__wrapper">
          <div class="btn-primary">
          <a
            :href="$router.resolve({
              name: 'ExhibitorDetails',
              query: { exhibitorid: exhibitor.Id },
              hash: '#top'
            }).href"
            target="_self"
          >
            View profile
          </a>

          </div>
        </div>
      </div>
    </div>
    <span v-if="exhibitors.length == 0" class="noDataClass">There are no exhibitors matching your search criteria.
      Please review
      your search or click RESET.</span>
  </div>
</template>

<script>
export default {
  name: "ExhibitorList",
  computed: {
    exhibitors: function () {
      return this.$store.state.exhibitorlistInitial.exhibitors;
    },
    logoSrc() {
      if (this.eventname === "japan") {
        return "https://www.japanenergyevent.com/media/2jsee45b/japan2025-logo.jpg";
      }   
      else if (this.eventname === "emf") {
        return "https://www.egyptminingforum.com/media/1wcjhzex/emf-header-logo.png";
      }
      if (this.eventname === "wuc") {
        return "https://www.worldutilitiescongress.com/media/rtdbps1s/wuc-logo2.jpg";
      } 
      else {
          return "https://www.japanenergyevent.com/media/2jsee45b/japan2025-logo.jpg";
      }
    }
  },
  mounted() {

    const url = window.location.href;
    const domain = url.split('/')[2];
    
    if (domain === "www.japanenergyevent.com/") {
      this.eventname = "japan";
    } 
    else if (domain === "worldutilitiescongress.com") {
      this.eventname = "wuc";
    }
    else if (domain === "https://www.egyptminingforum.com/") {
      this.eventname = "emf";
    }
    else {
      this.eventname = "japan";
    }

    this.getExhibitors(this.eventname);
  },
  methods: {
    getExhibitors(eventname) {  
      this.$store.dispatch("exhibitorInitialList", eventname);
    },
  },
};
</script>
